// extracted by mini-css-extract-plugin
module.exports = {"content":"NliAnnouncementModal_content__g4UGY"};